import Modal from './';
import Button from '../Button';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirmClick: () => void;
  title: string;
  subtitle: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  loading?: boolean;
  error?: string;
};

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirmClick,
  title,
  subtitle,
  cancelBtnText,
  confirmBtnText,
  loading,
  error
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width={'420px'}
      backgroundColor={'#F9FAFC'}
    >
      <div className='confirm-modal-container'>
        <div className='confirm-modal-header'>
          <div className='confirm-title'>{title}</div>
          <div className='confirm-sub-title'>{subtitle}</div>
        </div>

        <div className='confirm-submit-btn-wrapper'>
          <Button
            text={cancelBtnText ?? 'Cancel'}
            onClick={onClose}
            backgroundColor={'#ffffff'}
            color={'#2D334E'}
          />
          <Button
            text={confirmBtnText ?? 'Delete'}
            onClick={onConfirmClick}
            isLoading={loading}
          />
          {error && <div className='error-message'>{error}</div>}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
